import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { OrdersPage } from "../plugins/restaurant-menu/pages/OrdersPage";
import { CalendarPage } from "../plugins/restaurant-menu/pages/CalendarPage";
import { SettingsPage } from "../plugins/restaurant-menu/pages/SettingsPage";
import { BottomNavigation } from "../plugins/restaurant-menu/components/BottomNavigation";
import logoImage from "../assets/logo1.png";

const RestaurantPage: React.FC = observer(() => {
  const [activeTab, setActiveTab] = useState<
    "orders" | "calendar" | "settings"
  >("orders");

  const renderPage = () => {
    switch (activeTab) {
      case "orders":
        return <OrdersPage />;
      case "calendar":
        return <CalendarPage />;
      case "settings":
        return <SettingsPage />;
      default:
        return <OrdersPage />;
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3">
        <button
          onClick={() => {
            // Method 1: Try ReactNativeWebView postMessage (mobile WebView)
            if ((window as any).ReactNativeWebView) {
              (window as any).ReactNativeWebView.postMessage(
                JSON.stringify({ type: "NAVIGATE_BACK" })
              );
              return;
            }

            // Method 2: Try window.parent.postMessage (iframe)
            if (window.parent !== window) {
              window.parent.postMessage(
                JSON.stringify({ type: "NAVIGATE_BACK" }),
                "*"
              );
              return;
            }
          }}
          className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 12H5M5 12l7 7M5 12l7-7"
              stroke="#111827"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <img src={logoImage} alt="FasterHQ" className="h-8" />
        <h1 className="text-xl font-bold text-gray-900">FasterHQ</h1>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-hidden">{renderPage()}</main>

      {/* Bottom Navigation */}
      <BottomNavigation activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
});

export default RestaurantPage;
